<template>
  <div class="site_management">
    <van-sticky offset-top="0">
      <van-nav-bar title="卡位管理" left-arrow @click-left="goback()" />
    </van-sticky>

    <van-tabs v-model="active" title-active-color="#2295ff" color="#2295ff" @click="onClickTabs">
      <van-tab v-for="(item, index) in title" :key="index" :title="item">
      </van-tab>
    </van-tabs>

    <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
        <!-- 列表菜单栏 -->
        <div class="home_list">
          <div class="list_item" v-for="(item, index) in siteList" :key="index">
            <div class="item_content">
              <div class="content_img">
                <van-image height="100%" width="100%" :src="item.videoList.length > 0 ? item.videoList[0].thumbnailUrl : item.coverImageUrl" fit="cover" />
                <!-- 审核未完成显示审核状态结果 -->
                <div v-if="item.applyStatus != '2'">
                  {{ item.applyStatus_name }}
                </div>
                <!-- 审核成功且下架结果 -->
                <div v-if="item.shelfStatus === '0' && item.applyStatus === '2'">
                  {{ item.shelfStatus_name }}
                </div>
                <van-icon v-if="item.shelfStatus === '0' && item.videoList.length > 0" name="play" color="#fff" size="15" />
              </div>
              <div class="content_detail">
                <div class="fs15 line1 font-weightbold">
                  {{ item.name }}
                </div>
                <div class="fs11 color666 p-b10">
                  {{ item.district }}•{{ item.address }}
                </div>
                <div class="detail_tag line1">
                  <van-tag color="#1A85D2" plain v-for="site in item.siteCharacteristics_name" :key="site">{{ site }}
                  </van-tag>
                </div>
                <div class="detail_number">
                  <div class="number">
                    <div class="fs16 coloree0a24">{{ item.monthlyRent }}</div>
                    <div class="fs12 coloree0a24">元/㎡/月</div>
                    <div class="fs14 color000 m-l20">{{ item.area }}㎡</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item_action">
              <div v-if="item.shelfStatus === '1' && item.applyStatus === '2'" :style="{ color: item.shelfStatus === '1' && item.applyStatus === '2' ? '#000' : '#fff' }">
                展示中
              </div>
              <div class="action" style="text-align:left" v-if="item.applyStatus === '3'">
                拒绝原因：{{ item.reject_reason }}
              </div>
              <div v-if="item.applyStatus != '3' && item.applyStatus != '2'" :style="{ color: item.shelfStatus === '1' && item.applyStatus === '2' ? '#000' : '#fff' }">
                占位符
              </div>
              <div>
                <van-button v-if="item.applyStatus === '2'" class="action_delete" size="small" color="#D0D0D0" @click="siteDelete(item.id)">删除
                </van-button>
                <van-button v-if="item.applyStatus === '2'" size="small" type="default" @click="siteShelfStatus(item.id)">{{ item.shelfStatus === "1"
                  ?
                  "下架" : "上架"
                  }}</van-button>
                <van-button v-if="item.applyStatus === '2'" size="small" type="info" @click="toPlaceEdit(item.id)">编辑
                </van-button>
                <van-button size="small" type="primary" @click="toPlaceCopyShow(item.id)">复制</van-button>
              </div>
              <!-- <div class="action" v-if="item.applyStatus === '3'"> 拒绝原因：{{ item.reject_reason }} </div> -->
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-button color="#0CA7F0" class="management_push" type="primary" block @click="toPlaceIssue()">创建卡位</van-button>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="mask_loading" @click.stop>
        <!-- 表单 -->
        <van-form :show-error="false" @submit="onSubmit" error-message-align="right">
          <van-cell-group>
            <van-field input-align="right" type="number" required v-model="submitData.count" label="复制数量" placeholder="请输入" :rules="[{ required: true, message: '请输入复制数量' }]" />
          </van-cell-group>
          <van-button class="m-t25" block color="#195ED7" type="info" native-type="submit">立即复制</van-button>
        </van-form>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Button, Icon, Image, Tag, List, PullRefresh } from "vant";
import { Form, Field, CellGroup, Overlay, Tab, Tabs, } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Tag.name]: Tag,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Overlay.name]: Overlay,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  data() {
    return {
      active: 0,
      title: [
        "全部",
        "出租中",
        "空闲中",
      ],
      params: {
        type: 1,
        keyword: "",
        page: 1,
        size: 8,
      },
      //场地方列表
      siteList: [],
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      refreshing: false,
      showOverlay: false,
      submitData: {
        id: 0,
        count: "",
      },
    };
  },

  created() {
    this.active = (this.$route.query.type >= 0)? parseInt(this.$route.query.type):active;
    this.params.type = (this.$route.query.type) ? parseInt(this.active)+1:1;
    // 场地方管理-列表
    this.listBySiteSupplierId();
  },

  methods: {
    //下拉刷新
    onRefresh() {
      var that = this;
      setTimeout(() => {
        that.params.page = 1;
        // 场地方管理-列表
        that.listBySiteSupplierId();
        that.refreshing = false;
        that.finished = false;
      }, 1000);
    },

    //上拉加载
    onLoad() {
      var that = this;
      setTimeout(() => {
        that.listBySiteSupplierId();
      }, 1000);
    },

    // 场地方管理-列表
    listBySiteSupplierId() {
      var that = this;

      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      that.$api
        .siteListBySiteSupplierIdAPI(that.params)
        .then(function(res) {
          if (res.data.code === 200) {
            if (res.data.dataList.length > 0) {
              res.data.dataList.forEach((element) => {
                element.siteCharacteristics_name =
                  element.siteCharacteristics_name.split(",");
              });
            }
            // 如果是第一次进入页面page==1 直接赋值
            if (that.params.page === 1) {
              that.siteList = res.data.dataList;
            } else {
              that.siteList = [...that.siteList, ...res.data.dataList];
            }
            // 当还有数据是page++
            if (res.data.dataList.length > 0) {
              that.params.page++;
              that.loading = false;
            } else {
              // 如果没有数据加载完毕
              that.finished = true;
            }
            that.$Toast.clear();
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    //场地方管理-上下架
    siteShelfStatus(id) {
      var that = this;
      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      that.$api
        .siteShelfStatusAPI({ id: id })
        .then(function(res) {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "操作成功",
            });

          } else {
            that.$Notify({
              type: "danger",
              message: res.data.message,
            });
          }
          that.$Toast.clear();
          //下拉刷新
          that.onRefresh();
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    //场地方管理-删除
    siteDelete(id) {
      var that = this;
      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      that.$api
        .siteDeleteAPI({ ids: id })
        .then(function(res) {
          if (res.data.code === 200) {
            //下拉刷新
            that.onRefresh();
            that.$Notify({
              type: "success",
              message: "操作成功",
            });
            that.$Toast.clear();
          }
        })
        .catch(function(err) {
          console.log("error");
        });
    },

    //返回上一页
    goback() {
      this.$router.go(-1);
    },

    //跳转发布场地界面
    toPlaceIssue() {
      this.$router.push({ path: "/place/placeIssue" });
    },

    //跳转编辑场地界面
    toPlaceEdit(id) {
      this.$router.push({ path: "/place/placeEdit", query: { id: id } });
    },

    toPlaceCopyShow(id) {
      this.submitData.id = id;
      this.submitData.count = "";
      this.showOverlay = true;
    },

    //提交申请场地
    onSubmit() {
      var that = this;

      that.$Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      that.$api
        .siteCopyAPI(that.submitData)
        .then(function(res) {

          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "操作成功",
            });
            //下拉刷新
            that.onRefresh();
          } else {
            that.$Notify({
              type: "danger",
              message: "操作失败，请再次提交！",
            });
          }
          that.$Toast.clear();
          that.showOverlay = false;

        })
        .catch(function(err) {
          console.log("error");
        });
    },

    onClickTabs(name, title) {
      this.active = name;
      this.params.type = name+1;
      this.params.page = 1;
      this.listBySiteSupplierId();
    },
  },
};

</script>
<style lang="less" scoped>
// 列表菜单栏
.home_list {
  display: flex;
  flex-direction: column;

  .list_item {
    display: flex;
    flex-direction: column;
    padding: 0px 20px;

    .item_content {
      display: flex;
      flex-direction: row;
      padding-top: 10px;
      padding-bottom: 5px;

      .content_img {
        position: relative;
        width: 130px;
        height: 90px;
        border-radius: 3px;
        overflow: hidden;
        position: relative;

        div {
          position: absolute;
          background: rgba(0, 0, 0, 0.5);
          font-size: 20px;
          color: #fff;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .van-icon {
          position: absolute;
          bottom: 5px;
          right: 5px;
          background: rgba(0, 0, 0, 0.5);
          padding: 5px;
          border-radius: 100%;
        }
      }

      .content_detail {
        width: 250px;
        display: flex;
        flex-flow: column; //垂直排列
        justify-content: space-between; //两端对齐
        margin-left: 10px;

        /deep/ .detail_tag {
          margin-right: 5px;
          display: flex;
          flex-wrap: wrap;

          .van-tag--plain {
            padding: 2px 3px;
            margin-right: 5px;
            margin-top: 5px;
          }

        }

        .detail_number {
          display: flex;
          justify-content: space-between;
          flex-direction: row;
          align-items: flex-end;

          .number {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
          }
        }
      }
    }
  }

  .item_action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    margin-top: 5px;
    padding-bottom: 15px;
    border-bottom: 1px solid #f1f1f1;

    .action {
      font-size: 16px;
      margin-top: 10px;
      color: red;
    }

    .van-button {
      padding: 5px 15px;
      border-radius: 3px;
      font-size: 14px;
    }

    .action_delete {
      color: #000 !important;
    }
  }
}

.management_push {
  position: fixed !important;
  bottom: 0 !important;
}


.mask_loading {
  position: fixed;
  top: 50%;
  right: 0;
  left: 0;
  background: #fff;
  margin: auto;
  width: 80%;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/place/placeManagement.vue